<template>
    <div>
        <DCard
            padding
        >
            <ServiceFeeForm
                :errors="errors"
                :accounting-products="accountingProducts"
                :market-regions-options="marketRegionsOptions"
                :service-fee="serviceFee"
                @form-submitted="store"
            />
        </DCard>
    </div>
</template>

<script>
import ServiceFeeForm from '~@/Components/BillingAndAccounting/ServiceFees/Form'

export default {
    name: 'ServiceFeeCreate',
    components: {
        ServiceFeeForm
    },
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        accountingProducts: {
            type: Array,
            default: () => { return [] }
        },
        marketRegionsOptions: {
            type: Array,
            default: () => { return [] }
        },
        serviceFee: {
            type: Object,
            default: () => { return {} }
        },
    },
    methods: {
        store (form) {
            form.post(this.$route('tools.service-fees.store'))
        }
    }
}
</script>

<style scoped>

</style>
